import axios from 'axios'
import { API_HOST } from '../consts'

export const userHasDocument = async () =>
  axios
    .get(`${API_HOST}/v1/user_document`)
    .then((res) => res.status === 200)
    .catch(() => false)
